var render, staticRenderFns
import script from "./ElUtteranceInput.vue?vue&type=script&lang=js"
export * from "./ElUtteranceInput.vue?vue&type=script&lang=js"
import style0 from "./ElUtteranceInput.vue?vue&type=style&index=0&id=cbd2c2a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports